import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const CustomField = ({ className }) => (
    <div
        className={classNames([
            {
                [className]: className !== null,
            },
        ])}
        style={{ color: '#F00' }}
    >
        Custom field
    </div>
);

CustomField.propTypes = propTypes;
CustomField.defaultProps = defaultProps;

export default CustomField;
